/* globals define */

/*
  Purpose:
    - to allow sticky header feature in homepage, plp, and pip for the Desktop

  Dependencies:
    - hfConfig
*/

(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('header.stickyDesktop', ['hfConfig'],
      function load(hfConfig) {
        return factory(root, hfConfig);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    const _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.stickyDesktop = factory(root, hfConfig);
    /*eslint-enable*/
  }
})(this, function factory(root, hfConfig) {
  const module = {};
  const privateMethods = {};

  privateMethods.initialize = function initialize() {
    if (THD_GLOBAL.enableBassDesktopStickyHeader || THD_GLOBAL.enableHomeDesktopStickyHeader) {
      const isHomeDecor = !!(document.querySelector('.homeDecorFurnitureSubnav'));
      const microsoftBrowser = !!(navigator.userAgent.toLowerCase().indexOf('trident') > -1 || navigator.userAgent.toLowerCase().indexOf('edge') > -1);
      if (!isHomeDecor) {
        const Header3Div = document.querySelector('.Header3');
        if (!microsoftBrowser) { //Other than MICROSOFT Browsers
          Header3Div?.classList.add('Header3-sticky-desktop');
        } else {
          Header3Div?.classList.add('Header3-sticky-browser');
          document.querySelector("#messageBar").style.marginTop = Header3Div.clientHeight;
        }
      }
    }
  };

  /*
    * Public Methods
    */
  module.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  module.init = function init() {
    privateMethods.initialize();
    return this;
  };
  return module;
});